import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { CollectiveQueryResult } from 'graphql/generated'
import { useCallback } from 'react'

export const useUpdateCollectiveMembership = () => {
  const { collectiveDemo, updateDemoCache } = useCollectiveDemoContext()

  const updateCollectiveMembership = useCallback(
    (approved, privileged) => {
      const newCollective = {
        ...collectiveDemo
      } as CollectiveQueryResult['collective']

      if (!newCollective?.membership) {
        return
      }

      newCollective.membership.approved = approved
      newCollective.membership.privileged = privileged

      updateDemoCache({ ...newCollective })
    },
    [collectiveDemo, updateDemoCache]
  )

  return updateCollectiveMembership
}
